import { createStyles, makeStyles } from '@material-ui/core/styles';
import { colorsPalette } from '../../theme';

const useStyles = (secondaryColor = colorsPalette.gray) =>
  makeStyles(() =>
    createStyles({
      element: {
        fill: 'none',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '2',
      },
      elementFill: {
        fill: secondaryColor,
        fillRule: 'evenodd',
      },
    }),
  );

export default useStyles;
